<template>
  <div class="login flex align-center justify-center" >
     <div style="color: #FFFFFF;width:37%;text-align: left !important;">
		 <div class="font">我们的便携可靠方法</div>
		 <div style="font-size: 38px;margin-top: 15px;">查学校，查专业，查双选会就用HR校招助手!</div>
		 <div style="font-size: 14px;margin: 25px 0;">
			 <div>全国3012所高校，2500所中专任意查。</div>
			 <div style="margin:5px 0;">双选会信息及时掌握！就业办老师直接对接！校园宣讲会及时申请！</div>
			 <div>合适的生源及早联络！成为您的好助手是我们永恒的追求！！</div>
		 </div>
		 <div class="flex align-center">
			 <img src="../../assets/img/Play11.png" style="width: 100px;"/>
			 <div style="margin-left: 15px;">
				 <div class="font">找学校</div>
				 <div style="margin-top:5px ;">是什么使我们与众不同</div>
			 </div>
		 </div>
	 </div>
	 <div style="width:10%;"></div>
	 <div class="content flex direction-column justify-align-center" style="width:25%;height:65vh;border-radius: 20px;background: #FFFFFF;">
		 <div style="font-size: 22px;margin-bottom: 15px;width:80%;" class="flex align-center">
			 <img src="../../assets/img/_.png" class="xiaoshou" style="width:10px;height:auto;" @click="back()"/>
			<span style="width: 90%;text-align: center;">忘记密码</span>
		</div>
		 <div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
			 <div style="width:50px;text-align: left;">邮箱</div>
			 <input type="text" v-model="email" placeholder="请输入邮箱" />
		 </div>
		 <div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0 ">
		 	 <div style="width:50px;text-align: left;">验证码</div>
		 	 <input type="text" v-model="code" placeholder="请输入验证码" style="width:130px"/>
			 <div v-if=" codes==0" @click="hqcode()" class="xiaoshou">获取验证码</div>
			 <img  v-if=" codes!=0" :src="srcCode" @click="hqcode()" style="width:60px"/>
		 </div>
		 <div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
		 	 <div style="width:50px;text-align: left;">设置密码</div>
		 	 <input type="password" v-model="psw" placeholder="请设置密码" />
		 </div>
		 <div class="flex align-center font" style="border-bottom:1px solid #EBEEF5;padding:5px 0">
		 	 <div style="width:50px;text-align: left;">确认密码</div>
		 	 <input type="password" v-model="pswr" placeholder="请确认密码" />
		 </div>
		<div style="margin-top: 30px; width:240px;color:#FFFFFF;border-radius: 5px;padding:9px 0;text-align: center;" class="font backbg xiaoshou" @click="tijiao()">立即提交</div>
	 </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
			email:'',
			code:'',
			psw:'',
			pswr:'',
		  // 获取验证码
		  codes:'',
		  srcCode:''
        }
    },
    mounted(){
       
    },
	methods:{
		login(){
			this.$router.push('/login');
		},
		back(){
			 this.$router.go(-1);//返回上一层
		},
		hqcode(){
			// this.codes=1;
			if(!this.email) return this.$message.warning('请填写邮箱')
			this.$axios
				.post('/api/email',{email:this.email})
				.then((res) => {
					if(res.data.code==200){
						this.$message.success("发送验证码成功，请在邮箱中查看")
					}
				});
		},
		tijiao(){
			this.$axios
				.post('/api/forgetPwd', {
						password: this.psw,
						email: this.email,
						password_cfm:this.pswr,
						code:this.code
				})
				.then((res) => {
					console.log(this.code,"code");
					if (res.data.code == 200) {
						alert('重置密码成功');
					}
					alert(res.data.msg)
				});
		}
	}
}
</script>

<style>
	.login{
		width:100%;
		height:100vh;
		background-image: url(../../assets/img/de3.png);
		background-size: 100% 100%;
	}
	input{
		outline: none;
		border: none;
		padding:10px;
		width: 190px;
	}
	input::placeholder{
		color:#AAAAAA;
		font-size: 12px;
	}
</style>
